import { render, staticRenderFns } from "./BrandModelFormItem.vue?vue&type=template&id=b48e55fe&"
import script from "./BrandModelFormItem.vue?vue&type=script&lang=js&"
export * from "./BrandModelFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports